'use client';

import { ThemeEnum } from 'ui/src/components/Theme';
import ButtonLinkUI from 'ui/src/components/Button/ButtonLink';

const ButtonLink = ButtonLinkUI<ThemeEnum.Site>;

export default ButtonLink;
